import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { handleFacebookLogin } from "helpers/facebook-auth";
import { useMemo, useState } from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
import { connectSocialMedia } from "services/SauceService";

const ConnectMeta: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  const { business } = useSelector((state: BusinessState) => state.business);
  const socialMediaConencted = useMemo(() => {
    return (
      business?.socialMediasConnected?.some((socialMedia) =>
        ["instagram", "meta"].includes(
          socialMedia?.socialMediaName?.toLowerCase()
        )
      ) || true
    );
  }, [business]);

  const handleFacebookResponse = async (response: any) => {
    if (response.status === "connected") {
      const businessId = localStorage.getItem("businessId");
      const accessToken = response.authResponse.accessToken;
      setLoading(true);
      try {
        await connectSocialMedia({
          businessId,
          accessToken,
        });
        setLoading(false);
        message.success("Meta Business connected successfully");
        setVisible(false);
      } catch (error: any) {
        console.log(error);
        message.error(
          error?.response?.data?.message || "Error connecting Meta Business"
        );
        setLoading(false);
      }
    } else {
      console.log("User is not logged in with Facebook");
    }
  };

  const onClickSigninMeta = () => {
    handleFacebookLogin(handleFacebookResponse);
  };

  const onClickNotInterested = () => {
    setVisible(false);
  };

  if (visible && !socialMediaConencted) {
    return (
      <div
        className="blue-box"
        style={{ display: "flex", gap: 12, width: isMobile ? "auto" : 350 , margin: 16}}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 20,
            flex: 1,
            position: "relative",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: isMobile ? 14 : 18,
              fontWeight: 600,
              display: "flex",
              gap: 10,
            }}
          >
            <b style={{ fontSize: 20 }}>🔒</b> To track collaborations
            performance
          </p>
          <div
            style={{
              position: "absolute",
              top: -16,
              right: -4,
              cursor: "pointer",
              fontSize: 16,
            }}
            onClick={onClickNotInterested}
          >
            <CloseCircleOutlined />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              loading={loading}
              className="label-strong"
              onClick={onClickSigninMeta}
            >
              Connect Meta Business Account
            </Button>
            {/* <Button
              type="link"
              size="small"
              style={{
                padding: 0,
                textDecoration: "underline",
                marginRight: 12,
              }}
              loading={loading}
              onClick={onClickNotInterested}
            >
              Hide
            </Button> */}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default ConnectMeta;
